export const demandsQueryKeys = {
  all: () => ['/demands'] as const,
  lists: () => [...demandsQueryKeys.all(), 'list'] as const,
  list: (params: Record<string, unknown>) =>
    [...demandsQueryKeys.lists(), JSON.stringify(params)] as const,
  detail: (id: number) => ['/demands', id] as const,
  comments: (id: number) => ['/demands', id, 'comments'] as const,
  attachments: (id: number) => ['/demands', id, 'attachments'] as const,
  evidence: (id: number) => ['/demands', id, 'evidence'] as const,
  reviewers: (id: number) => ['/demands', id, 'reviewers'] as const,
  reviewerDecisions: (id: number, reviewerRecordId: number) =>
    ['/demands', id, 'reviewers', reviewerRecordId, 'decisions'] as const,
  activity: (id: number) => ['/demands', id, 'activity'] as const,
  items: (id: number) => ['/demands', id, 'items'] as const,
  checklist: (id: number) => ['/demands', id, 'checklist'] as const,
  matrix: () => ['getMatrixDemands'] as const,
};
